import Vue from "vue";

Vue.filter("roundNumber", function (value) {
  return value? value.toLocaleString(undefined, {
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
  }):"0,00";
});

Vue.filter("dateFormat", function (date) {
  return date ? new Intl.DateTimeFormat("it-IT", { month: "2-digit", day: "2-digit", year:"numeric" }).format(new Date(date)) : null;
});

Vue.filter("currencyFormat", function (curr) {
  return new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR" }).format(curr ? curr : 0);
});
